import * as React from "react";
import Footer from "../footer";
import { Sora } from "next/font/google";
import Header from "../header";
import localFont from "next/font/local";
import Head from "next/head";
import MenuDrawer from "../drawer/menu-drawer";


const sora = Sora({
  weight: ["300", "400", "500", "700"],
  style: ["normal"],
  subsets: ["latin"],
  display: "swap",
  variable: "--font-sora",
});

const grotesk = localFont({
  src: [
    {
      path: "../../../public/fonts/FKGroteskTrial-Regular.otf",
      weight: "400",
      style: "normal",
    },
    {
      path: "../../../public/fonts/FKGroteskNeueTrial-Medium.otf",
      weight: "500",
      style: "normal",
    },
    {
      path: "../../../public/fonts/FKGroteskNeueTrial-Bold.otf",
      weight: "700",
      style: "normal",
    },
    {
      path: "../../../public/fonts/FKGroteskTrial-Thin.otf",
      weight: "300",
      style: "normal",
    },
  ],
  variable: "--font-grotesk",
  display: "swap",
});
const havletica = localFont({
  src: [
    {
      path: "../../../public/fonts/Helvetica Regular.otf",
      weight: "400",
      style: "normal",
    },
    {
      path: "../../../public/fonts/HelveticaNeueThin.otf",
      weight: "300",
      style: "normal",
    },
  ],
  variable: "--font-havletica",
  display: "swap",
});

const Layout = ({ children }) => {
  return (
    <div
      className={`w-full h-auto block relative bg-white min-h-screen ${sora.variable} ${grotesk.variable} ${havletica.variable} font-grotesk`}
    >

    <Head>
    <link rel="preload" href="/fonts/FKGroteskTrial-Regular.otf" as="font" type="font/otf" crossOrigin="anonymous" />
    <link rel="preload" href="/fonts/FKGroteskNeueTrial-Medium.otf" as="font" type="font/otf" crossOrigin="anonymous" />
    <link rel="preload" href="/fonts/FKGroteskNeueTrial-Bold.otf" as="font" type="font/otf" crossOrigin="anonymous" />
    <link rel="preload" href="/fonts/FKGroteskTrial-Thin.otf" as="font" type="font/otf" crossOrigin="anonymous" />
    <link rel="preload" href="/fonts/Helvetica Regular.otf" as="font" type="font/otf" crossOrigin="anonymous" />
    <link rel="preload" href="/fonts/HelveticaNeueThin.otf" as="font" type="font/otf" crossOrigin="anonymous" />
    </Head>


      <Header />
      <MenuDrawer />
      <main className={`w-full`}>{children}</main>
      <Footer />
    </div>
  );
};
export default Layout;
